import { get } from '../../utils/object-helpers';

const DESCRIPTION_FIELD_NAME = 'aboutDescription';

export default class {
    onCreate(input) {
        const subTitles = get(input, 'subTitles', []);
        this.editDebounceTimer = null;
        this.state = {
            about: subTitles.find(it => it.contentKey !== 'EDITABLE'),
            aboutEditDescription: subTitles.find(it => it.contentKey === 'EDITABLE')
        };
    }
    onMount() {
        setTimeout(() => {
            this.updateText(get(this.state.about, 'textSpans.0.text', ''));
        }, 0);
    }
    onInput(input) {
        const updatedAboutText = get(input, `globalState.profileEdit.payload.${DESCRIPTION_FIELD_NAME}`);
        if (updatedAboutText !== undefined) {
            this.state.about = {
                ...this.state.about,
                textSpans: [
                    {
                        ...this.state.about.textSpans[0],
                        text: updatedAboutText
                    }
                ]
            };
        }
    }
    handleTextUpdate(ev) {
        if (this.editDebounceTimer) {
            clearTimeout(this.editDebounceTimer);
            this.editDebounceTimer = null;
        }
        this.editDebounceTimer = setTimeout(() => {
            this.updateText(ev.target.value);
        }, 0);
    }
    updateText(value) {
        const eventDetail = {
            action: {
                name: 'UPDATE_PROFILE_FIELD'
            },
            payload: {
                field: DESCRIPTION_FIELD_NAME,
                value
            }
        };
        document.dispatchEvent(new CustomEvent('presenceEdit', { detail: eventDetail }));
    }
}
